import React, { useState } from "react"
import PropTypes from "prop-types"
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { css } from "@emotion/core"
import Colors from "./colors"


// onSelect should update selected
const Picker = ({options, onSelect, selected}) => {
  return (
    <Dropdown overlay={
      options.length > 0 &&
      <Menu>
        {(options).map(option => 
          <Menu.Item key={option.id} onClick={() => {onSelect(option)}}>{option.name}</Menu.Item>
        )}
      </Menu>
    }>
      <button 
        //onClick={e => e.preventDefault()}
        css={css`
          background-color: transparent;
          border: none;
          border-bottom: 1px solid ${Colors.darkblue};
          cursor: pointer;
          text-decoration: none;
          display: inline;
          margin: 0;
          padding: 0;
        `}
      >
        {selected.name} <DownOutlined />
      </button>
    </Dropdown>
  )
}

const OptionProp = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string
})

Picker.propTypes = {
  options: PropTypes.arrayOf(OptionProp).isRequired,
  //defaultLabel: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: OptionProp,
}

export default Picker